// swCleanup.js - 강화된 Service Worker 청소
const FLAG = 'sw-nuked-v2';

async function sleep(ms) { 
  return new Promise(r => setTimeout(r, ms)); 
}

async function unregisterAllSW() {
  if (!('serviceWorker' in navigator)) return 0;
  const regs = await navigator.serviceWorker.getRegistrations();
  let cnt = 0;
  for (const r of regs) { 
    try { 
      if (await r.unregister()) cnt++; 
    } catch (e) {
      console.warn('[SW-Cleanup] unregister failed:', e);
    }
  }
  return cnt;
}

async function clearAllCaches() {
  if (!('caches' in window) || !caches.keys) return 0;
  const keys = await caches.keys();
  await Promise.all(keys.map(k => caches.delete(k)));
  return keys.length;
}

async function waitControllerGone(timeoutMs = 1500) {
  const start = performance.now();
  while (navigator.serviceWorker && navigator.serviceWorker.controller) {
    if (performance.now() - start > timeoutMs) break;
    await sleep(100);
  }
}

export async function nukeServiceWorkersOnce() {
  if (sessionStorage.getItem(FLAG)) return;
  
  console.log('[SW-Cleanup] Starting enhanced Service Worker cleanup...');
  
  try {
    // 🔧 [추가] Service Worker 존재 여부 확인
    const swCount = await unregisterAllSW();
    const cacheCount = await clearAllCaches();
    
    // 🔧 [수정] Service Worker 청소 후 자동 새로고침 제거
    if (swCount > 0) {
      await waitControllerGone(1500);
      console.log(`[SW-Cleanup] Removed ${swCount} Service Workers, ${cacheCount} caches`);
      sessionStorage.setItem(FLAG, '1');
      // 🔧 [제거] 자동 새로고침 제거 - Service Worker 청소만 수행
      console.log('[SW-Cleanup] Service Worker cleanup completed - no auto reload');
    } else {
      console.log('[SW-Cleanup] No Service Workers found, skipping reload');
      sessionStorage.setItem(FLAG, '1');
    }
  } catch (e) {
    sessionStorage.setItem(FLAG, '1'); // 루프 방지
    console.warn('[SW-Cleanup] failed:', e);
    // 🔧 [제거] 에러 발생 시에도 자동 새로고침 제거
    console.log('[SW-Cleanup] Error recovery completed - no auto reload');
  }
}
